import { ScaleSymLog } from 'd3-scale';

import type {
  DateTimeFormatter,
  FormatterWithPrecision,
} from '../../core/types/formatter.js';
import {
  getCategoricalTicks,
  getDateNumericalFormattedTicks,
  getFormattedTicks,
} from '../../core/utils/formatter-by-ticks.js';
import { isCategorical, isLinear, isLogarithmic } from '../types/guards.js';
import type {
  XYChartAxisInternal,
  AnyXYChartScale,
} from '../types/xy-chart-internals.js';

export function getTicksFormattedByConfig(
  config: XYChartAxisInternal | undefined,
  numTicks: number,
  scale: AnyXYChartScale | undefined,
  formatter: FormatterWithPrecision | DateTimeFormatter | undefined,
) {
  const axisType = config?.type || '';

  return isCategorical(axisType)
    ? getCategoricalTicks(scale)
    : isLogarithmic(axisType)
    ? getFormattedTicks(
        numTicks,
        scale as ScaleSymLog<number, never>,
        undefined,
        formatter,
      )
    : getDateNumericalFormattedTicks(
        numTicks,
        scale,
        isLinear(axisType) ? config?.unit : undefined,
        formatter,
      );
}
